import { Component, inject, input, model } from '@angular/core';
import { HeaderVersamentoOperazioniMassive } from '../models/operazioni-massive.model';
import { DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';
import { MenuItem } from 'primeng/api';
import { DestroyReportFileFormat } from '../models/operazioni-massive-service.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';

@Component({
  selector: 'app-riepilogo-versamento-dialog',
  template: `
    <p-dialog [(visible)]="isOpen" [modal]="true" [closable]="false" [closeOnEscape]="false" [resizable]="false"  [style]="{ width: '50%' }">
      <p-header>
        <span>Riepilogo Versamento</span>
      </p-header>
        <!-- <app-verbale-distruzione [protocol]="protocol()" [header]="header()" [documents]="documents()"></app-verbale-distruzione> -->
          <app-riepilogo-versamenti [header]="header()" [items]="documents()" [showOnly]="true"/>
      <p-footer>
        <p-splitButton  [disabled]="!header || !documents().length"
                icon="fas fa-download" label="Scarica Riepilogo" (onClick)="print()" 
                styleClass="pr-0 mr-0"
                [model]="downloadCommands"/>
        <button pButton type="button" label="Chiudi" class="p-button-secondary ml-2" title="Chiudi" (click)="close()"></button>
      </p-footer>      
    </p-dialog>
  `,
  styles: ``
})
export class RiepilogoVersamentoDialogComponent {
  private readonly operazioniMassive = inject(OperazioniMassiveService);
      
  public id = input.required<number|undefined>();

  public header = input<HeaderVersamentoOperazioniMassive | undefined>(undefined);
  public documents = input.required<DocumentiSearchDocRow[]>();
  public isOpen = model<boolean>(false);

  public downloadCommands: MenuItem[];

  constructor() {
    this.downloadCommands = [
      {
          label: 'Formato PDF',
          command: () => {
              this.print();
          }
      },
      {
          label: 'Formato Word',
          command: () => {
              this.printWord();
          }
      },
    ];  
  }

  public close(): void {
    this.isOpen.set(false);
  }
  public print(): void {
    this.generateReport( DestroyReportFileFormat.PDF);
  }

  public printWord(): void {
    this.generateReport( DestroyReportFileFormat.Word);
  }

  public generateReport( format: DestroyReportFileFormat = DestroyReportFileFormat.Word): void {
  
    setTimeout(() => {
      const operazioneId = this.id();
      
      if (operazioneId)
        this.operazioniMassive.report(operazioneId, format);
    }, 100);
  }    
}
